import { gql } from 'graphql-request';

export const FETCH_WATCH_AND_WIN_CONFIG_QUERY = gql`
  query ($mapperId: String!) {
    watchAndWinConfig(mapperId: $mapperId) {
      onboardingBackgroundImage
      onboardingBackgroundImageDesktop
      quizPageBackground
      quizPageBackgroundDesktop
      bannerBackgroundImage
      bannerLogoImage
      quizTitleImage
      quizPageTitle
      quizInstructions
      ctaText
      cta2Text
      termsAndConditionsUrl
      howToPlayUrl
      resultInfoText
      resultScreenImage
      sponsorLogo
      sponsorText
      sponsorDeeplink
      resultScreenVideoPWA
    }
  }
`;

export const FETCH_WATCH_AND_WIN_LEADERBOARD_QUERY = gql`
  query ($date: String, $type: String, $mapperId: String) {
    watchAndWinLeaderBoard(date: $date, type: $type, mapperId: $mapperId) {
      entries {
        title {
          value
          type
        }
        results {
          title
          rewardsInfo {
            imageUrl
            placeHolderText
          }
          winners {
            name
            location
          }
        }
      }
      activeDates
    }
  }
`;

export const FETCH_WATCH_AND_WIN_PLAYER_STAT_IN_CAMPAIGN_QUERY = gql`
  query ($mapperId: String!) {
    playerStatsInCampaign(mapperId: $mapperId) {
      contests {
        date
        hasParticipated
        correctAnswers
        totalQuestions
        logoUrl
        gameMetaInfo {
          name
        }
      }
    }
  }
`;
